const TRANSLATION = {
  buyModal: {
    afterFree: 'Selepas percubaan percuma anda',
    btn: 'Cuba Percuma',
    freeTrial: 'Cubaan Percuma 3 Hari',
    monthLabel: 'bulan',
    selectLabel: 'Pilih pelan',
    title: 'Pelan Langganan',
    yearLabel: 'tahun',
  },
  contact: {
    block1:
      'Untuk penyesuaian, soalan, atau cadangan, sila hubungi kami di contact@noam.tools. Kami akan memberi respons dengan cepat.',
    block2:
      'Sokong kami dengan memberi penilaian kepada kami di kedai Google Apps Extension dengan ★★★★★.',
    block3: 'Bantu orang lain dengan berkongsi sambungan ini:',
    title: 'Hubungi Kami',
  },
  help: {
    AquickOverviewOfNoam: 'Gambaran Ringkas tentang Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Pengurusan Kemasukan kegemaran',
    Fixedplugin: 'Plugin Tetap',
    Focusing: 'Memfokuskan',
    Free: 'Bebas',
    FreeTrialBenefits: 'Faedah Percubaan Percuma',
    GoWithWikipedia: 'Gunakan Wikipedia',
    GoWithYouTube: 'Gunakan YouTube',
    HoverTranslation: 'Terjemahan Melayang',
    Howtouse: 'Cara Menggunakan',
    ImageTranslation: 'Terjemahan Imej',
    InstantTranslation: 'Terjemahan Segera',
    Membership: 'Keahlian',
    NoamHelp: 'Noam membantu anda menterjemahkan dan meringkaskan',
    PDFparallelTranslation: 'Terjemahan Selari PDF',
    ParallelTranslation: 'Terjemahan Selari',
    SkipAllSteps: 'Langkau Semua Langkah',
    Summary: 'Ringkasan',
    Translation: 'Terjemahan',
    TryItForFree: 'Cuba Percuma',
    Video: 'Video',
    VideoSummary: 'Ringkasan Video',
    VideoTranslation: 'Terjemahan Video',
    WebSummary: 'Ringkasan Web',
    WordSelectionTranslation: 'Penterjemahan Pemilihan Perkataan',
    benefits: 'Kami mempunyai faedah yang menunggu anda!',
    dayFree: 'Cuba Percuma 3 Hari',
    done: 'Selesai',
    next: 'Seterusnya',
    pin: 'Sematkan Noam untuk Akses Lebih Mudah～～',
    planIsNotExist: 'Pelan tidak tersedia',
    startWiki: 'Mari kita mulakan dengan Wikimedia!',
    startYoutube: 'Mari kita mulakan dengan YouTube!',
    try: 'Cuba Ia',
    tryNow: 'Cuba sekarang!',
  },
  home: {
    PDFTranslate: {
      desc: 'Terjemahan Dwibahasa + Chat PDF',
      sub1: {
        desc: 'Membaca dwibahasa membolehkan anda membandingkan teks asal dan terjemahan secara bersebelahan, meningkatkan kecekapan membaca.',
        title: 'Membaca Dwibahasa',
      },
      sub2: {
        desc: 'AI menganalisis dan meringkaskan, serta boleh menjawab soalan anda berdasarkan kandungan PDF.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'Terjemahan PDF berkuasa AI untuk ketepatan dan kecekapan yang lebih tinggi.',
        title: 'Ketepatan dan Kecekapan',
      },
      title: 'Terjemahan PDF',
    },
    aiAssistant: {
      desc: 'Membuat Terjemahan Web Lebih Pintar dan Mudah',
      panel1: {
        desc: 'Terjemahan silang rujukan dwibahasa membantu anda membandingkan teks asal dengan terjemahan supaya anda dapat memahami dengan lebih baik dan meningkatkan kecekapan membaca anda.',
        title: 'Terjemahan Dwibahasa',
      },
      panel2: {
        left: {
          desc: 'Apabila melayari halaman web, letakkan tetikus di atas kandungan yang perlu anda terjemahkan untuk melihat terjemahan.',
          title: 'Terjemahan Hover',
        },
        right: {
          desc: 'Apabila melayari halaman web, pilih teks yang anda ingin terjemahkan untuk melihat terjemahannya.',
          title: 'Penterjemahan Pemilihan Teks',
        },
      },
      panel3: {
        one: {
          desc: 'Terjemahkan dan ringkaskan halaman web serta kandungan video bila-bila masa, di mana-mana sahaja, untuk pengalaman yang lebih lancar!',
          title: 'Klik dan Tunjuk',
        },
        three: {
          desc: 'Model bahasa besar yang didorong oleh AI memastikan ketepatan dan konsistensi terjemahan untuk pengalaman membaca yang lebih baik.',
          title: 'Didorong oleh AI',
        },
        two: {
          desc: 'Liputan penuh pelbagai bahasa, bacaan bebas halangan dwibahasa, terjemahan dengan satu klik - rasai perbezaannya!',
          title: 'Lebih Komprehensif dan Mudah',
        },
      },
      panel4: {
        tab1: {
          desc: 'Pakar kecekapan anda - dengan menggunakan ChatGPT, Noam menterjemahkan dan meringkaskan kandungan video YouTube untuk menjimatkan masa anda!',
          key: 'Video',
          title: 'Terjemahan & Ringkasan Video',
        },
        tab2: {
          desc: 'Klik untuk menterjemahkan imej semasa melayari web.',
          key: 'Imej',
          title: 'Terjemahan Imej',
        },
        tab3: {
          desc: 'Mengekstrak maklumat utama dari halaman web serta memberikan ringkasan dengan serta-merta, meningkatkan kecekapan bacaan anda.',
          key: 'Web',
          title: 'Terjemahan & Ringkasan Web',
        },
        tag1: 'Ringkas',
        tag2: 'Efisien',
        tag3: 'Mudah difahami',
      },
      title: 'Pembantu AI',
    },
    getStart: 'Mula Sekarang',
    getStartedForFree: 'Mula menggunakan secara percuma',
    howItWork: {
      desc: 'Noam menggabungkan model AI untuk menyediakan pengalaman pintar kepada pengguna bagi terjemahan dan ringkasan halaman web merentas bahasa, terjemahan PDF dan imej, serta terjemahan dan ringkasan video',
      title: 'Cara ia berfungsi',
    },
    lastBlock: { desc: 'Terjemahan AI yang lebih baik untuk pengalaman membaca yang lebih lancar' },
    top: {
      desc: 'Noam ialah sambungan pelayar AI percuma yang membantu anda menterjemah dan meringkaskan halaman web, video dan kandungan PDF.\n      Bergabung dengan Noam dan alami keajaibannya!',
      title1: 'Satu Ajaib',
      title2: 'Satu Klik',
    },
    userReviews: { desc: 'Ulasan lima bintang di Chrome Web Store', title: 'Ulasan Pengguna' },
  },
  installTips: {
    btn: 'Cuba Sekarang',
    text: 'Pasang "Noam Browser Plugin" untuk membuka kunci lebih banyak ciri! Rujukan silang web,\n    ringkasan video web, dan banyak lagi!',
  },
  locale: {
    af: 'Afrikaans',
    am: 'Amharik',
    ar: 'Bahasa Arab',
    as: 'Bahasa Assam',
    auto: 'Autodapati',
    az: 'Azerbaijan',
    ba: 'Bashkir',
    bg: 'Bulgaria',
    bn: 'Bangla',
    bo: 'Tibet',
    bs: 'Bosnia',
    ca: 'Katalan',
    cs: 'Ceko',
    cy: 'Wales',
    da: 'Bahasa Denmark',
    de: 'Jerman',
    dsb: 'Sorbian Bawah',
    dv: 'Divehi',
    el: 'Yunani',
    en: 'Bahasa Inggeris',
    es: 'Sepanyol',
    et: 'Estonian',
    eu: 'Basque',
    fa: 'Parsi',
    fi: 'Finland',
    fil: 'Filipino',
    fj: 'Fijian',
    fr: 'Perancis',
    frCA: 'Perancis (Kanada)',
    ga: 'Iris',
    gl: 'Galicia',
    gom: 'Konkani',
    gu: 'Gujarati',
    ha: 'Hausa',
    he: 'Ibrani',
    hi: 'Hindi',
    hr: 'Kroat',
    hsb: 'Sorbian Atas',
    ht: 'Kriol Haiti',
    hu: 'Hungaria',
    hy: 'Armenia',
    id: 'Indonesia',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'Islandia',
    it: 'Italiano',
    iu: 'Inuktitut',
    iuLatn: 'Inuktitut (Latin)',
    ja: 'Jepun',
    ka: 'Georgia',
    kk: 'Kazakhstan',
    km: 'Khmer',
    kmr: 'Kurdish (Utara)',
    kn: 'Kannada',
    ko: 'Korea',
    ku: 'Kurdish (Pusat)',
    ky: 'Kirgizi',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'Lithuania',
    lug: 'Ganda',
    lv: 'Latvia',
    lzh: 'Bahasa Cina (Sastera)',
    mai: 'Maithili',
    mg: 'Bahasa Malagasi',
    mi: 'Māori',
    mk: 'Makedonia',
    ml: 'Melayualam',
    mnCyrl: 'Mongolia (Cyrillic)',
    mnMong: 'Mongolia (Tradisional)',
    mr: 'Marathi',
    ms: 'Melayu',
    mt: 'Bahasa Malta',
    mww: 'Hmong Daw',
    my: 'Myanmar (Bahasa Burma)',
    nb: 'Norwegia',
    ne: 'Nepal',
    nl: 'Belanda',
    noSearchLang: 'Bahasa tidak disokong',
    nso: 'Sesotho Utara',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Otomi Querétaro',
    pa: 'Punjabi',
    pl: 'Poland',
    placeholder: 'Cari',
    prs: 'Dari',
    ps: 'Pashto',
    pt: 'Portuges (Brazil)',
    ptPT: 'Portugis (Portugal)',
    ro: 'Rumania',
    ru: 'Rusia',
    run: 'Rundi',
    rw: 'Kinyarwanda',
    sd: 'Sindhi',
    si: 'Sinhala',
    sk: 'Slovakia',
    sl: 'Slovenia',
    sm: 'Samoan',
    sn: 'Shona',
    so: 'Somali',
    sq: 'Albania',
    srCyrl: 'Serbia (Cyrillic)',
    srLatn: 'Serbia (Latin)',
    st: 'Sesotho',
    sv: 'Swedia',
    sw: 'Swahili',
    ta: 'Tamil',
    te: 'Telugu',
    th: 'Thai',
    ti: 'Tigrinya',
    tk: 'Turkmen',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'Setswana',
    to: 'Tongan',
    tr: 'Turki',
    tt: 'Tatar',
    ty: 'Tahiti',
    ug: 'Uyghur',
    uk: 'Ukraine',
    ur: 'Urdu',
    uz: 'Uzbek (Latin)',
    vi: 'Vietnam',
    xh: 'Xhosa',
    yo: 'Yoruba',
    yua: 'Yucatec Maya',
    yue: 'Canton (Tradisional)',
    zh: 'Cina',
    zhHans: 'Cina Ringkas',
    zhHant: 'Cina Tradisional',
    zu: 'Zulu',
  },
  login: {
    and: 'dan',
    btn: 'Log Masuk dengan Google',
    btn1: 'Log Masuk Sekarang',
    desc: 'Log masuk untuk membuka kunci lebih banyak pengalaman',
    policy: 'Dasar Privasi',
    terms: 'Terma Penggunaan',
    tips: 'Dengan mendaftar, saya bersetuju dengan',
    title: 'Selamat datang ke Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Ikuti', twitter: 'Twitter' },
    legal: { policy: 'Dasar Privasi', terms: 'Terma Perkhidmatan', title: 'Undang-undang' },
    product: {
      image: 'Terjemahan Imej',
      pdf: 'Terjemahan PDF',
      title: 'Produk',
      video: 'Terjemahan & Ringkasan Video',
      web: 'Terjemahan & Ringkasan Web',
    },
    resources: { title: 'Sumber' },
    tools: { title: 'Alat', pdf: 'Terjemahan PDF' },
  },
  pageHeader: {
    contact: 'Hubungi',
    help: 'Bantuan',
    logout: 'Log Keluar',
    logoutSucc: 'Log keluar.',
    pricing: 'Harga',
    settings: 'Tetapan',
    signUp: 'Log Masuk',
  },
  pdf: {
    autoDetect: 'Automatik-Pengesanan',
    cancelBtn: 'Batal',
    cancelUpload: 'Batal',
    chatPdf: {
      summaryError: 'Peringkasan gagal, sila cuba lagi kemudian',
      chatError: 'Perbualan gagal, sila cuba lagi kemudian',
      Search: 'Cari',
      cancel: 'Batal',
      chatTitle: 'Selamat datang ke Noam! Berikut adalah ringkasan PDF anda:',
      clear: 'Jelas',
      clearContent:
        'Ini akan memulakan perbualan baharu. Perbualan semasa tidak akan disimpan. Adakah anda pasti?',
      clearDialogTitle: 'Sila Sahkan',
      clearSucc: 'Diluluskan',
      copy: 'Salin',
      copySucc: 'Disalin',
      delete: 'Padam',
      deleteCancel: 'Batal',
      deleteContent: 'PDF ini tidak boleh dipulihkan selepas dipadam. Adakah anda pasti?',
      deleteOk: 'Padam',
      deleteSuccess: 'Dihapus',
      deleteTitle: 'Sahkan Padam',
      expand: 'Runtuh',
      historyTitle: 'Sejarah',
      listError: 'Gagal memuat senarai bacaan. Sila cuba lagi kemudian, atau hubungi sokongan.',
      loading: 'Memuatkan...',
      noDataDesc: 'Tiada sejarah lagi.',
      noMore: 'Tiada lagi kandungan.',
      placeholder: 'Tanya apa sahaja tentang PDF ini',
      summaryTitle: 'Anda mungkin tertarik dengan soalan-soalan berikut:',
    },
    collectionEmpty: 'Koleksi anda kosong.',
    collectionTab: 'Nota',
    dataLoading: 'Memuatkan...',
    dialogContent: 'Adakah anda pasti ingin memadamkan ini?',
    dialogTitle: 'Sila Pengesahan',
    download: {
      both: 'Dwibahasa',
      btn: 'Simpan',
      cancel:
        'Menutup tetingkap ini akan membatalkan muat turun PDF. Adakah anda pasti mahu membatalkan?',
      desc: 'Simpan ke Peranti: Memuat turun terjemahan sebagai imej; Simpan & Cetak: Memuat turun terjemahan dalam format asal, dengan sokongan salinan.',
      download: 'Muat turun',
      downloadMsg1: 'Kemajuan Terjemahan PDF:',
      downloadMsg2: 'Masa Anggaran yang Tersisa:',
      downloadSucc: 'PDF sudah sedia! Klik untuk simpan.',
      downloadTip:
        'Memuat turun PDF. Jangan tutup tetingkap ini untuk mengelakkan ralat muat turun.',
      error: 'Gagal menyimpan. Cuba cetak sebagai ganti.',
      fileName: 'Nama Fail:',
      fileType: 'Jenis Fail:',
      loading: 'Menyimpan...',
      loading2: 'Memuatkan...',
      minute: 'Minit...',
      msg1: 'Sesetengah terjemahan dalam dokumen ini lebih panjang daripada teks asal, dan mungkin bertindih dalam fail yang dimuat turun. Kami mengesyorkan untuk membacanya di halaman web.',
      msg2: 'Terjemahan belum selesai. Sila muat turun selepas terjemahan selesai.',
      msg3: '2. Sesetengah terjemahan terlalu panjang. Baca pada laman web untuk mengelakkan pertindihan teks.',
      msg4: 'Tugasan terjemahan sedang berlangsung. Sila cuba lagi selepas ia selesai.',
      progress:
        'Menerjemahkan PDF. Kemajuan: {{progress}}, Anggaran masa tinggal: {{minutes}} minit...',
      save: 'Simpan ke Peranti',
      savePrint: 'Simpan & Cetak',
      success: 'Dimuat turun',
      trans: 'Hanya Terjemahan',
      transContinue: 'Teruskan Terjemahan',
    },
    downloadBtn: 'Muat turun',
    dragTipModal: {
      black: 'ruang',
      leftKey: 'butang kiri',
      ok: 'Paham',
      press: 'Tekan',
      tips: 'untuk seret dan lihat',
    },
    entry: 'PDF',
    fileErrMsg: 'Gagal membaca fail. Sila cuba lagi kemudian, atau hubungi sokongan.',
    fileMsg: 'Saiz fail semasa:',
    fileMsg2: 'Sila muat naik fail yang lebih kecil daripada 300MB.',
    freeBannerBtn: 'Naik taraf',
    freeBannerTips: 'Had Terjemahan PDF Percuma Telah Dicapai',
    guide: {
      placeholder: 'Tampal pautan PDF di sini',
      start: 'Mulakan Terjemahan',
      text1: 'Pembacaan Dwibahasa',
      text2:
        'Baca secara dwibahasa untuk membandingkan teks asal dan terjemahan secara berdampingan, meningkatkan kecekapan anda.',
      text3: 'Bercakap Dengan PDF Anda',
      text4:
        'Analisis dan ringkasan berkuasa AI. Ajukan soalan tentang PDF anda, dan dapatkan jawapan serta-merta.',
      text5: 'Tepat & Efisien',
      text6: 'Terjemahan PDF berkuasa AI untuk ketepatan dan kecekapan yang lebih tinggi.',
      title1: 'Terjemahan Dwibahasa',
      title2: 'Bercakap Dengan PDF Anda',
      toast: 'Sila masukkan pautan PDF dalam talian yang sah yang berakhir dengan .pdf',
    },
    hasTransTask: 'Tugasan terjemahan sedang dijalankan. Sila tunggu.',
    hoverTrans: 'Perenggan Terjemahan dengan Melayang',
    initial: 'Terjemahkan PDF',
    installText: 'Solusi segala keperluan untuk terjemahan harian.',
    installText2: 'Sila pasang sambungan terlebih dahulu',
    installTips:
      'Pasang sambungan untuk lebih banyak terjemahan PDF dan terjemahan laman web yang lebih lancar:',
    kw: 'pengikat kertas',
    link: 'pautan',
    listError: 'Gagal memuatkan PDF. Sila cuba lagi kemudian, atau hubungi sokongan.',
    memoTotalCount: 'Jumlah 1 item',
    new: 'fail baru',
    noId: 'ID Fail tidak ditemui.',
    notPdf: 'Hanya fail PDF.',
    okBtn: 'Padam',
    okBtn2: 'Paham',
    original:
      'Anda ialah AI yang sangat tepat dan boleh dipercayai yang direka untuk menjana output JSON yang mematuhi betul-betul Skema JSON yang ditentukan.\n        \nAnda mesti mematuhi peraturan berikut:\n1. Mematuhi struktur Skema JSON dengan ketat.\n2. Memadankan semua jenis data, medan yang diperlukan, dan kekangan dengan tepat.\n3. JANGAN sertakan sebarang teks tambahan, penjelasan, markdown, atau ulasan.\n4. HANYA keluarkan objek JSON — tiada blok kod, tiada preambel, tiada pembungkus.\n\nMaklumat skema disediakan di bawah.\n- Nama Skema: translate_result\n- Skema JSON:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Selari',
    parseErrDialogContent:
      'Pautan PDF ini tidak boleh diterjemahkan secara langsung. Sila muat turun PDF dan muat naiknya untuk diterjemahkan.',
    parseErrTips: 'Gagal mengurai fail',
    parseFileToast: 'Gagal menterjemahkan fail. Sila cuba lagi kemudian, atau hubungi sokongan.',
    pdfLoading: 'Mengurai...',
    searchPlaceholder: 'Cari',
    selectTrans: 'Pilih Teks untuk Terjemahkan',
    shareBtn: 'Kongsi',
    shareBtnText1: 'Hasilkan Pautan Kongsi',
    shareBtnText2: 'Kemas Kini Kandungan Berkongsi',
    shareModal: {
      cancel: 'Batal',
      copy: 'Salin',
      copySucc: 'Pautan Disalin',
      custom: 'Penyesuaian:',
      errMsg:
        'Kandungan yang dipilih belum diterjemahkan sepenuhnya. Sila terjemahkan sebelum berkongsi.',
      gen: 'Kongsi',
      modify: 'Edit',
      notSupport: 'Bahasa ini tidak disokong pada masa ini.',
      page: 'Halaman',
      pageNuErr: 'Sila masukkan nombor halaman yang sah.',
      range: 'Skop:',
      remain: 'baki',
      remain1: 'Jumlah masa dianggarkan:',
      search: 'Carian',
      settings: 'Tetapan Kongsi:',
      shareSetting: 'Tetapan Kongsi',
      shareText: 'Kongsi',
      shareTips: 'Kongsi pautan PDF yang diterjemahkan dengan rakan-rakan anda:',
      sourceLang: 'Dari:',
      target: 'Kepada:',
      text1: 'Tetapan Kongsi',
      text2: 'Generate Pautan Kongsi',
      totalPage: 'Jumlah 1 halaman',
      trans: 'Terjemahkan',
      translateTips:
        'Petua: Jika terjemahan mengambil masa yang lama, anda boleh menutup tetingkap ini dan berkongsi kemudian.',
      translating: 'Menerjemahkan PDF...',
      update: 'Kemas Kini Pautan Kongsi',
    },
    shareMsg1: 'Pautan perkongsian telah dijana.',
    shareMsg2: 'Kandungan kongsi telah dikemas kini.',
    shareMsg3: 'Gagal menjana pautan perkongsian. Sila cuba lagi kemudian, atau hubungi sokongan.',
    shareMsg4:
      'Gagal mengemaskini kandungan kongsi. Sila cuba lagi kemudian, atau hubungi sokongan.',
    shareTips: 'Terjemahan PDF anda sudah siap! Kongsikan dengan rakan-rakan anda.',
    start: 'Mula Percubaan Percuma Anda',
    thumbnail: 'Isi Kandungan',
    toast1: 'Memuatkan PDF. Sila cuba lagi kemudian.',
    toast2: 'Kandungan PDF sedang diproses. Dialog pada masa ini tidak disokong.',
    toast3: 'Sedang memuat turun. Sila cuba lagi selepas muat turun selesai.',
    toolbar: { Adjust: 'Tetapkan', autoFit: 'Auto-Sesuaikan' },
    trans: 'Terjemahan',
    transSucc: 'Terjemahan berjaya!',
    unLoginToast: 'Sila log masuk untuk menggunakan ciri ini.',
    uploadBtn: 'Muat naik',
    uploadErr: 'Pemuatan fail gagal. Sila cuba lagi kemudian, atau hubungi sokongan.',
    uploadErrSignUrl:
      'Gagal mendapatkan URL muat naik. Sila cuba lagi kemudian, atau hubungi sokongan.',
    uploadMsg1: 'Seret dan letakkan fail anda di sini.',
    uploadMsg2: 'Jenis Fail yang Disokong: PDF  |  Saiz Fail Maksimum: 300MB',
    uploadMsg3: 'Klik untuk memilih atau seret dan lepaskan fail di sini.',
    uploading: 'Memuat naik',
    uploadingMsg: 'Memuat naik. Sila tunggu.',
    uploadingMsg1: 'Fail sedang dimuat naik. Sila cuba lagi kemudian.',
    uploadingMsg2: 'Satu fail sedang dalam proses penukaran. Sila cuba lagi kemudian.',
    uploadingMsg3:
      'Permintaan kemajuan penukaran gagal. Sila cuba lagi kemudian, atau hubungi sokongan.',
    uploadingMsg4:
      'Noam tidak boleh mengakses fail tempatan. Sila muat naik PDF secara manual untuk diterjemahkan.',
    uploadingMsg5: 'Gagal mendapatkan URL fail. Sila cuba lagi kemudian, atau hubungi sokongan.',
    video: 'video',
    vipBannerBtn: 'Naik taraf',
    vipBannerTips: 'Anda telah mencapai had terjemahan PDF untuk bulan ini.',
    webTrans: 'Rujukan Saling Penuh',
  },
  pricing: {
    FAQ: 'Soalan Lazim',
    FQAObj: {
      a1: 'Ya, Noam menawarkan pelan percuma yang anda boleh gunakan serta-merta.',
      a2: 'Kami menawarkan tiga pelan keahlian: Pro, Pro+, dan Enterprise. Anda boleh memilih untuk membayar bulanan atau tahunan. Pembayaran tahunan menawarkan penjimatan yang ketara.',
      a3: 'Semua ciri tersedia pada kedua-dua pelan. Perbezaan utama ialah kos: langganan tahunan kos lebih rendah secara keseluruhan. Langganan bulanan dicaj setiap bulan, manakala pelan tahunan dicaj sekali setiap tahun.',
      a4: 'Anda boleh membatalkan langganan anda pada bila-bila masa dalam Tetapan Akaun anda.',
      q1: 'Adakah terdapat pelan percuma?',
      q2: 'Apakah pelan harga dan pilihan pembayaran yang tersedia?',
      q3: 'Apakah perbezaan antara melanggan bulanan berbanding tahunan?',
      q4: 'Bagaimana saya boleh membatalkan langganan saya?',
    },
    around: 'Sekitar',
    billedMonthly: 'Dibayar Setiap Bulan',
    billedYearly: 'Dibayar Setahun',
    day: 'hari',
    desc: 'Bandingkan Pelan & Pilih yang Terbaik',
    detailedCompare: 'Bandingkan Pelan',
    discount: '20% Diskaun',
    enterprise: {
      benefit1: 'Sokongan Pelanggan Utama',
      benefit2: 'Pelbagai Pengguna',
      benefit3: 'Penyelesaian yang Disesuaikan',
      benefit5: 'Pengurus Akaun Khusus',
      btn: 'Hubungi Kami',
      recommendText: 'Pelan Tersuai (≥3 orang)',
      talkToUs: 'Hubungi Kami',
    },
    free: {
      benefit1: 'Terjemahan segera 100 kali/hari',
      benefit2: 'Terjemahan & Ringkasan Laman Web',
      benefit3: '30 Terjemahan Imej',
      benefit4: 'Terjemahan & Ringkasan Video',
      benefit5: '10 Terjemahan PDF',
      benefit6: '5,000 token',
      btn: 'Cuba Percuma',
      recommendText: 'Uji Percubaan Percuma',
    },
    imageTranslation: 'Terjemahan Imej',
    month: 'bulan',
    monthly: 'Bulanan',
    pageTitle: 'Harga',
    pdf: {
      chat: 'Permintaan Chat PDF',
      maxPage: 'Maks. Halaman setiap PDF',
      translation: 'Terjemahan PDF',
    },
    preMonth: 'Setiap bulan',
    pro: {
      benefit1: 'Sokongan Pelanggan Keutamaan',
      benefit2: '1,000,000 token/bulan',
      benefit3: 'Terjemahan & Ringkasan Laman Web',
      benefit4: '200 Terjemahan Imej',
      benefit5: 'Terjemahan & Ringkasan Video',
      benefit6: '200 Terjemahan PDF',
      btn: 'Mula',
      recommendText: 'Paling Popular',
    },
    proPlus: {
      benefit1: 'Sokongan Pelanggan Utama',
      benefit2: '3,000,000 token/bulan',
      benefit3: 'Terjemahan & Ringkasan Laman Web',
      benefit4: '500 Terjemahan Imej',
      benefit5: 'Terjemahan & Ringkasan Video',
      benefit6: '500 Terjemahan PDF',
      recommendText: 'Nilai Tertinggi',
    },
    video: { summary: 'Ringkasan Video', translation: 'Terjemahan Video' },
    web: {
      contrastiveTranslation: 'Terjemahan Dwibahasa',
      dictionaryTranslation: 'Penterjemahan Pilihan',
      hoverTranslation: 'Terjemahan Hover',
      instantTranslation: 'Terjemahan Segera',
      summary: 'Ringkasan Halaman Web',
    },
    yearly: 'Setiap tahun',
  },
  privacy: {
    block1:
      'Noam ("Noam," "kami," "kita," atau "kita") menghormati privasi anda dan komited untuk melindungi sebarang maklumat yang kami perolehi daripada anda atau mengenai anda. Dasar Privasi ini menerangkan amalan kami mengenai pengumpulan atau penggunaan maklumat peribadi daripada penggunaan anda terhadap laman web, aplikasi dan perkhidmatan kami (secara kolektif, "Perkhidmatan"). Dasar Privasi ini tidak terpakai kepada kandungan yang kami uruskan bagi pihak pelanggan produk perniagaan kami, seperti API kami. Penggunaan data ini tertakluk kepada perjanjian pelanggan kami, yang meliputi akses kepada dan penggunaan produk-produk ini.',
    block10:
      'Kami melaksanakan langkah-langkah teknikal, pentadbiran, dan organisasi yang munasabah dari segi komersial untuk melindungi maklumat peribadi dalam talian dan luar talian daripada kehilangan, penyalahgunaan, dan akses tanpa kebenaran, pendedahan, perubahan, atau tindakan bermusuhan. Walau bagaimanapun, tiada penghantaran internet atau e-mel boleh menjamin keselamatan atau ketepatan yang lengkap. Khususnya, e-mel yang dihantar kepada kami atau dari kami mungkin tidak selamat. Oleh itu, anda perlu berhati-hati terutamanya apabila memutuskan maklumat apa yang akan dihantar kepada kami melalui perkhidmatan atau e-mel. Selain itu, kami tidak bertanggungjawab terhadap sebarang halangan tetapan privasi atau langkah-langkah keselamatan dalam perkhidmatan atau tetapan keselamatan atau langkah-langkah keselamatan Laman Web Pihak Ketiga. Kami akan mengekalkan maklumat peribadi anda selama yang diperlukan untuk memberi anda perkhidmatan atau untuk tujuan perniagaan sah yang lain, seperti menyelesaikan pertikaian, sebab-sebab keselamatan dan keselamatan, atau mematuhi kewajipan undang-undang kami. Tempoh masa kami mengekalkan maklumat peribadi akan bergantung kepada banyak faktor, seperti jumlah, sifat, sensitiviti maklumat, risiko potensi penggunaan atau pendedahan tanpa kebenaran, tujuan kami memproses maklumat, dan pertimbangan lain yang mempunyai pengikat undang-undang.',
    block11:
      'Kami mungkin mengemas kini Dasar Privasi ini dari semasa ke semasa. Apabila kami berbuat demikian, kami akan memuatkan versi yang dikemas kini di halaman ini, kecuali jika diperlukan sebaliknya oleh undang-undang yang berkenaan.',
    block12:
      'Jika anda mempunyai sebarang soalan yang belum dijawab atau kekhuatan mengenai Dasar Privasi ini, sila hubungi perkhidmatan pelanggan kami. Emel:',
    block2:
      'Kami mengumpul maklumat peribadi berikut ("Maklumat Peribadi") yang berkaitan dengan anda:',
    block3:
      'Maklumat yang Disediakan oleh Anda: Apabila anda membuat akaun untuk menggunakan perkhidmatan kami atau berkomunikasi dengan kami, kami akan mengumpul maklumat peribadi seperti berikut:',
    block4:
      'Maklumat Peribadi yang Diterima Secara Automatik daripada Penggunaan Perkhidmatan Anda: Apabila anda mengakses, menggunakan, atau berinteraksi dengan perkhidmatan, kami menerima maklumat berikut mengenai akses, penggunaan, atau interaksi anda ("Maklumat Teknikal"):',
    block5: 'Kami mungkin menggunakan maklumat peribadi untuk tujuan berikut:',
    block6:
      'Ringkasan atau Maklumat Tanpa Identiti: Kami boleh mengagregatkan atau menghapuskan identiti maklumat peribadi untuk mengelakkan penggunaannya semula untuk tujuan pengenalan dan menggunakan maklumat tersebut untuk menganalisis keberkesanan perkhidmatan kami, menambahbaik dan menambah ciri kepada perkhidmatan kami, menjalankan penyelidikan, dan untuk tujuan yang serupa. Selain itu, kami boleh menganalisis tingkah laku umum dan ciri pengguna perkhidmatan kami serta berkongsi maklumat terkumpul dengan pihak ketiga, menerbitkan maklumat terkumpul tersebut, atau menjadikannya tersedia secara umum. Kami boleh mengumpul maklumat terkumpul melalui perkhidmatan, melalui cookie, dan melalui cara lain yang diterangkan dalam Dasar Privasi ini. Kami akan mengekalkan dan menggunakan maklumat tanpa identiti dalam bentuk anonim atau tanpa identiti, dan kami tidak akan cuba mengenal pasti semula maklumat tersebut melainkan jika diperlukan oleh undang-undang.',
    block7:
      'Dalam kes tertentu, kami mungkin memberikan maklumat peribadi anda kepada pihak ketiga tanpa notis lanjut kepada anda, kecuali jika diperlukan oleh undang-undang:',
    block8:
      ' bergantung kepada lokasi geografi anda, individu di Kawasan Ekonomi Eropah, United Kingdom dan seluruh dunia mungkin mempunyai hak-hak statutori tertentu berkenaan dengan maklumat peribadi mereka. Contohnya, anda mungkin mempunyai hak untuk:',
    block9:
      'Perkhidmatan ini mungkin mengandungi pautan ke laman web lain yang tidak dikendalikan atau dikawal oleh Noam, termasuk perkhidmatan media sosial ("Laman Web Pihak Ketiga"). Maklumat yang anda kongsi dengan Laman Web Pihak Ketiga akan dikawal oleh dasar privasi khusus dan terma perkhidmatan Laman Web Pihak Ketiga, bukan oleh Dasar Privasi ini. Kami menyediakan pautan ini untuk kemudahan dan tidak membayangkan sokongan atau semakan kami terhadap laman web ini. Sila hubungi Laman Web Pihak Ketiga secara langsung untuk mendapatkan maklumat mengenai dasar privasi dan terma mereka.',
    subBlock1:
      'Maklumat Akaun: Apabila anda membuat akaun di platform kami, kami akan mengumpul maklumat yang berkaitan dengan akaun anda, termasuk nama anda, maklumat hubungan, kata laluan akaun, maklumat kad pembayaran dan sejarah transaksi ("Maklumat Akaun").',
    subBlock10: 'Menyediakan, mengurus, mengekalkan, dan/atau menganalisis perkhidmatan;',
    subBlock11: 'Berkomunikasi dengan anda;',
    subBlock12: 'Membangunkan produk dan perkhidmatan baharu;',
    subBlock13:
      'Mencegah penipuan, aktiviti jenayah, atau penyalahgunaan perkhidmatan kami, serta melindungi keselamatan sistem IT, seni bina dan rangkaian kami;',
    subBlock14: 'Melakukan pemindahan perniagaan;',
    subBlock15:
      'Mematuhi kewajipan undang-undang dan prosiding undang-undang, melindungi hak, privasi, keselamatan, atau harta kami, serta hak-hak tersebut bagi anak syarikat kami, anda, atau pihak ketiga yang lain.',
    subBlock16:
      'Pembekal dan Pembekal Perkhidmatan: Untuk membantu kami memenuhi keperluan operasi perniagaan dan melaksanakan perkhidmatan serta fungsi tertentu, kami mungkin menyediakan maklumat peribadi kepada pembekal dan pembekal perkhidmatan, termasuk pembekal perkhidmatan hos, pembekal perkhidmatan awan, dan pembekal perkhidmatan teknologi maklumat lain, perisian komunikasi e-mel, dan pembekal perkhidmatan analitik web, dsb. Rakan kongsi ini hanya akan mengakses, memproses atau menyimpan maklumat peribadi atas arahan kami semasa melaksanakan tugas mereka untuk kami.',
    subBlock17:
      'Pemindahan Perniagaan: Jika kami terlibat dalam urus niaga strategik, penyusunan semula, kebangkrutan, pengambilalihan kebangkrutan, atau peralihan perkhidmatan kepada pembekal lain (secara kolektif, "Urus Niaga"), maklumat peribadi anda dan maklumat lain mungkin dikongsi dengan rakan kongsi urus niaga dan pihak lain yang membantu dalam Urus Niaga semasa pemeriksaan mendalam serta dipindahkan sebagai sebahagian daripada Urus Niaga bersama dengan aset lain kepada syarikat pengganti atau anak syarikat.',
    subBlock18:
      'Keperluan Undang-undang: Kami boleh berkongsi maklumat peribadi anda dengan pihak berkuasa kerajaan, rakan seindustri, atau pihak ketiga lain, termasuk maklumat interaksi anda dengan perkhidmatan kami, (1) jika diperlukan oleh undang-undang atau jika kami percaya tindakan sedemikian diperlukan untuk mematuhi kewajipan undang-undang; (2) untuk melindungi dan mempertahankan hak atau harta kami; (3) jika kami secara sepihak menentukan bahawa terdapat pelanggaran terhadap syarat, dasar, atau undang-undang kami; (4) untuk mengesan atau mencegah penipuan atau aktiviti haram lain; (5) untuk melindungi produk, pekerja, atau pengguna kami, atau keselamatan awam, keselamatan, integriti; atau (6) untuk mempertahankan diri terhadap liabiliti undang-undang.',
    subBlock19: 'akses maklumat peribadi anda dan maklumat tentang cara ia diproses.',
    subBlock2:
      'Apabila anda menggunakan perkhidmatan kami, kami mengumpul maklumat peribadi daripada input anda, muat naik fail, atau maklum balas yang diberikan kepada kami ("Kandungan").',
    subBlock20: 'Meminta penghapusan maklumat peribadi anda daripada rekod kami.',
    subBlock21: 'Sahkan atau kemas kini maklumat peribadi anda.',
    subBlock22: 'Memindahkan maklumat peribadi anda kepada pihak ketiga (portabiliti data).',
    subBlock23: 'Hadkan cara kami memproses maklumat peribadi anda.',
    subBlock24:
      'Tarik balik kebenaran anda—apabila kami bergantung kepada kebenaran sebagai asas undang-undang untuk pemprosesan, anda boleh menarik balik kebenaran anda pada bila-bila masa.',
    subBlock25: 'Tidak setuju dengan cara kami memproses maklumat peribadi anda.',
    subBlock26: 'Meningkatkan perkhidmatan kami dan menjalankan penyelidikan;',
    subBlock3:
      'Maklumat Komunikasi: Jika anda menghantar mesej kepada kami, kami akan mengumpul nama anda, maklumat hubungan, dan kandungan mesej anda ("Maklumat Komunikasi").',
    subBlock4:
      'Maklumat Media Sosial: Kami mempunyai halaman di laman web media sosial seperti Instagram, Facebook, Medium, Twitter, YouTube dan LinkedIn. Apabila anda berinteraksi dengan halaman media sosial kami, kami akan mengumpul maklumat peribadi yang anda pilih untuk disediakan kepada kami, seperti butiran hubungan anda ("Maklumat Sosial"). Selain itu, syarikat yang menghosting halaman media sosial kami mungkin memberikan kami maklumat terkumpul dan analisis tentang aktiviti media sosial kami.',
    subBlock5:
      'Data Log: Maklumat yang dihantar secara automatik oleh pelayar anda semasa menggunakan perkhidmatan kami. Data log termasuk alamat Protokol Internet (IP) anda, jenis dan tetapan pelayar, tarikh dan masa permintaan anda, serta cara anda berinteraksi dengan laman web kami.',
    subBlock6:
      'Data Penggunaan: Kami mungkin secara automatik mengumpul maklumat mengenai penggunaan anda terhadap perkhidmatan, seperti jenis kandungan yang anda lihat atau berinteraksi dengan, ciri-ciri yang anda gunakan, tindakan yang anda lakukan, serta zon masa anda, negara, tarikh dan masa capaian, ejen pengguna dan versi, jenis komputer atau peranti mudah alih, dan sambungan komputer anda.',
    subBlock7:
      'Maklumat Peranti: Ini termasuk nama peranti, sistem operasi, pengenal peranti, dan pelayar yang anda gunakan. Maklumat yang dikumpul mungkin bergantung pada jenis peranti yang anda gunakan dan tetapan perantinya.',
    subBlock8:
      'Cookies: Kami menggunakan cookies untuk menjalankan dan menguruskan perkhidmatan kami serta meningkatkan pengalaman anda. "Cookie" ialah maklumat yang dihantar oleh laman web yang anda lawati kepada penyemak imbas anda. Anda boleh tetapkan penyemak imbas anda untuk menerima semua cookies, menolak semua cookies, atau memberitahu anda apabila cookie disediakan supaya anda boleh memutuskan sama ada untuk menerima setiap kali. Walau bagaimanapun, menolak cookies mungkin menghalang anda daripada menggunakan atau menjejaskan paparan atau fungsi kawasan atau ciri tertentu laman web secara negatif. Untuk maklumat lanjut tentang cookies, sila lawati All About Cookies.',
    subBlock9:
      'Analitik: Kami mungkin menggunakan pelbagai produk analitik dalam talian yang menggunakan kuki untuk membantu kami menganalisis cara pengguna menggunakan perkhidmatan kami dan meningkatkan pengalaman anda semasa menggunakan perkhidmatan tersebut.',
    subTitle1: 'Maklumat Peribadi yang Kami Kumpul',
    subTitle2: 'Cara Kami Menggunakan Maklumat Peribadi',
    subTitle3: 'Pendedahan Maklumat Peribadi',
    subTitle4: 'Hak-Hak Anda',
    subTitle5: 'Pautan ke Laman Web Lain',
    subTitle6: 'Keselamatan dan Penyelenggaraan Maklumat',
    subTitle7: 'Pengubahsuaian Dasar Privasi',
    subTitle8: 'Cara Hubungi Kami',
    title: 'Dasar Privasi',
    updateTime: 'Dikemas kini: 15 Mac 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Terima Semua',
    text: 'Untuk meningkatkan pengalaman anda, kami menggunakan cookies untuk mempersonalisasikan kandungan dan perkhidmatan.',
    title: 'Laman web ini menggunakan cookies',
  },
  slogen: 'Pembantu AI yang paling mudah',
  stripe: {
    contact: 'Hubungi kami di contact@noam.tools sekiranya mempunyai sebarang soalan!',
    fail: {
      btn: 'Cuba lagi',
      text1: 'Kami tidak dapat memproses pembayaran anda.',
      text2: 'Semak sambungan anda dan cuba lagi.',
      title: 'Pembayaran gagal',
    },
    succ: {
      btn: 'Jalan',
      text1: 'Selamat datang ke Noam',
      text2: 'mari kita mulakan!',
      title: 'Tahniah',
    },
  },
  terms: {
    block1: 'Terima kasih kerana menggunakan Noam!',
    block10:
      'Yuran dan Penyampaian Bil. Anda akan membayar semua yuran ("Yuran") mengikut harga dan syarat pada halaman harga yang berkaitan atau seperti yang disetujui secara bertulis antara kami. Kami berhak untuk membetulkan kesilapan harga atau kesilapan walaupun kami telah mengeluarkan invois atau menerima pembayaran. Anda akan memberikan maklumat penyampaian bil yang lengkap dan tepat, termasuk kaedah pembayaran yang sah dan dibenarkan. Kami akan mengenakan caj ke atas kaedah pembayaran anda secara berkala seperti yang disetujui, tetapi kami boleh mengubah tarikh penyampaian bil dengan munasabah. Anda memberi kuasa kepada Noam, anak syarikatnya, dan pengurus pembayaran pihak ketiga untuk mengenakan caj ke atas kaedah pembayaran anda. Jika pembayaran anda gagal, kami akan memberikan notis bertulis kepada anda dan mungkin menggantung akses kepada Perkhidmatan sehingga pembayaran diterima. Kecuali jika dinyatakan lain dalam perjanjian ini, pembayaran tidak boleh dikembalikan.',
    block11:
      '(b) Cukai. Kecuali dinyatakan sebaliknya, Yuran tidak termasuk apa-apa cukai persekutuan, negeri, tempatan dan asing, duti, dan penilaian serupa ("Cukai"). Anda bertanggungjawab untuk semua Cukai yang berkaitan dengan pembelian anda, kecuali Cukai berdasarkan pendapatan bersih kami yang akan kami fakturkan kepada anda. Anda bersetuju untuk membayar Cukai tersebut dengan segera dan memberikan kepada kami kenyataan privasi yang sah dari segi undang-undang serta mendapatkan persetujuan yang diperlukan untuk mengendalikan data tersebut, dan anda menjamin kepada kami bahawa anda mengendalikan data tersebut sesuai dengan undang-undang yang berkenaan.',
    block12:
      '(c) Perubahan Harga. Kami boleh mengubah harga kami dengan memberitahu anda melalui akaun anda dan/atau laman web kami. Peningkatan harga akan berkuat kuasa serta-merta selepas dimuatkan. Sebarang perubahan harga akan terpakai kepada Yuran untuk akaun anda selepas tarikh berkuat kuasa perubahan tersebut.',
    block13:
      '(d) Perselisihan dan Bayaran Lewat Tempoh. Jika anda ingin mempersoalkan sebarang Yuran atau Cukai, sila hubungi contact@noam.tools dalam tempoh tiga puluh (30) hari dari tarikh invois.',
    block14:
      '(e) Penggunaan Percuma. Anda tidak boleh membuat beberapa akaun untuk mendapatkan kredit percuma. Jika kami menentukan bahawa anda tidak menggunakan kredit percuma dengan niat baik, kami boleh mengenakan bayaran standard kepada anda atau menghentikan akses kepada Perkhidmatan.',
    block15:
      '(a) Keselamatan Rahsia. Anda mungkin mempunyai akses kepada maklumat rahsia Noam. Anda hanya boleh menggunakan maklumat rahsia seperti yang dibenarkan di bawah terma ini untuk tujuan menggunakan Perkhidmatan. Anda tidak boleh mendedahkan maklumat rahsia kepada mana-mana pihak ketiga, dan anda akan melindungi maklumat rahsia dengan cara yang tidak kurang perlindungan daripada bagaimana anda melindungi maklumat rahsia sendiri yang serupa, sekurang-kurangnya dengan penjagaan yang munasabah. Maklumat rahsia ialah maklumat bukan awam yang ditetapkan sebagai rahsia oleh Noam atau yang secara munasabah harus dianggap sebagai rahsia dalam keadaan tertentu, termasuk perisian, spesifikasi, dan maklumat perniagaan bukan awam yang lain. Maklumat rahsia tidak termasuk maklumat yang: (1) menjadi tersedia umum kepada orang ramai tanpa kesalahan di pihak anda; (2) anda miliki dalam pemilikan anda tanpa sebarang kewajipan keselamatan rahsia sebelum menerima ia di bawah terma ini; (3) didedahkan secara sah kepada anda oleh pihak ketiga tanpa sebarang kewajipan keselamatan rahsia; atau (4) dibangunkan secara bebas oleh anda tanpa menggunakan maklumat rahsia. Anda boleh mendedahkan maklumat rahsia jika diperlukan oleh undang-undang, mahkamah, atau perintah kerajaan yang lain, tetapi anda mesti memberikan notis bertulis terdahulu kepada Noam dengan cara yang munasabah dan, sejauh mungkin, melakukan usaha yang munasabah untuk mengehadkan skop pendedahan, termasuk membantu kami menentang permintaan pendedahan.',
    block16:
      '(b) Keselamatan. Anda mesti melaksanakan langkah-langkah yang munasabah dan sesuai untuk membantu melindungi akses dan penggunaan anda terhadap Perkhidmatan. Jika anda mendapati sebarang kelemahan atau pelanggaran yang berkaitan dengan penggunaan anda terhadap Perkhidmatan, anda mesti menghubungi Noam dengan segera dan memberikan butiran kelemahan atau pelanggaran tersebut.',
    block17:
      '((c) Pemprosesan Data Peribadi. Jika anda menggunakan Perkhidmatan untuk memproses data peribadi, anda mesti menyediakan penyataan privasi yang mencukupi dari segi undang-undang dan mendapatkan kebenaran yang diperlukan untuk memproses data tersebut, dan anda menjamin kepada kami bahawa anda mengendalikan data tersebut sesuai dengan undang-undang yang berkenaan.',
    block18:
      '(a) Penamatan; Penangguhan. Terma-terma ini akan berkuat kuasa dari penggunaan pertama anda terhadap Perkhidmatan dan akan kekal berkuat kuasa sehingga ditamatkan. Anda boleh menamatkan terma-terma ini pada bila-bila masa atas sebarang sebab dengan berhenti menggunakan Perkhidmatan dan Kandungan. Kami boleh menamatkan terma-terma ini dengan notis terdahulu atas sebarang sebab. Kami boleh menamatkan terma-terma ini serta-merta dengan memberitahu anda jika anda melanggar secara substantif Seksyen 2 (Keperluan Penggunaan), Seksyen 5 (Kerahsiaan, Keselamatan, dan Perlindungan Data), Seksyen 8 (Penyelesaian Perselisihan), atau Seksyen 9 (Terma Am), atau jika hubungan kami dengan mana-mana pembekal teknologi pihak ketiga di luar kawalan kami berubah, atau untuk mematuhi undang-undang atau permintaan kerajaan. Kami boleh menangguhkan akses anda kepada Perkhidmatan jika anda gagal mematuhi terma-terma ini, atau jika penggunaan anda menimbulkan risiko keselamatan kepada kami atau mana-mana pihak ketiga, atau jika kami mengesyaki penggunaan anda adalah penipuan atau mungkin mendedahkan kami atau mana-mana pihak ketiga kepada liabiliti.',
    block19:
      '(b) Kesan Penamatan. Apabila diputuskan, anda hendaklah berhenti menggunakan Perkhidmatan dan segera mengembalikan atau memusnahkan sebarang maklumat sulit seperti yang diarahkan oleh kami. Peruntukan-peruntukan dalam terma ini yang secara semulajadinya perlu bertahan selepas penamatan atau tamat tempoh, termasuk tetapi tidak terhad kepada Seksyen 3 dan 5-9, akan terus bertahan.',
    block2:
      'Terma Penggunaan ini terpakai kepada penggunaan anda terhadap perkhidmatan Noam, termasuk antara muka pengaturcaraan aplikasi, perisian, alat, perkhidmatan pembangun, data, dokumentasi, dan laman web kami (secara kolektif dirujuk sebagai "Perkhidmatan"). Dengan menggunakan Perkhidmatan kami, anda bersetuju untuk mematuhi terma ini. Dasar Privasi kami menerangkan bagaimana kami mengumpul dan menggunakan maklumat peribadi.',
    block20:
      '(a) Indemniti. Anda akan mempertahankan, mendemniti, dan memelihara kami, anak syarikat kami, dan kakitangan kami daripada sebarang tuntutan, kerugian, dan perbelanjaan (termasuk yuran peguam) yang timbul daripada atau berkaitan dengan penggunaan anda terhadap Perkhidmatan, termasuk Kandungan anda, penggunaan anda terhadap produk atau perkhidmatan yang berkaitan dengan Perkhidmatan, dan pelanggaran anda terhadap terma ini atau undang-undang yang berkenaan.',
    block21:
      '(b) Penafian. Perkhidmatan disediakan "sebagaimana adanya". Sehingga tahap yang dibenarkan oleh undang-undang, kami dan anak syarikat serta pemberi lesen kami tidak membuat sebarang pernyataan atau jaminan apa jua jenis berkaitan Perkhidmatan dan tidak memberikan sebarang jaminan, termasuk tetapi tidak terhad kepada jaminan kebolehjualan, kesesuaian untuk tujuan tertentu, kualiti yang memuaskan, tidak melanggar hak cipta, dan kegunaan tanpa gangguan, serta sebarang jaminan yang timbul daripada urusan atau penggunaan perdagangan. Kami tidak menjamin bahawa Perkhidmatan akan berterusan, tepat, atau bebas daripada ralat, atau bahawa mana-mana Kandungan akan selamat, tidak hilang, atau tidak diubah.',
    block22:
      '(c) Had Liabiliti. Kami, sekutunya, atau pemberi lesen kami tidak akan bertanggungjawab untuk sebarang kerugian tidak langsung, sampingan, khas, akibat, atau punitive, termasuk kehilangan keuntungan, kehilangan reputasi, kehilangan penggunaan, kehilangan data, atau kerugian tidak ketara yang lain, walaupun kami telah dimaklumkan tentang kemungkinan kerugian sedemikian. Di bawah terma ini, jumlah liabiliti kami tidak akan melebihi Yuran yang anda bayar kepada Perkhidmatan dalam tempoh dua belas (12) bulan sebelum tuntutan atau seratus dolar AS ($100), mana-mana yang lebih besar. Had dalam seksyen ini terpakai sehingga tahap maksimum yang dibenarkan oleh undang-undang yang berkaitan.',
    block23:
      'Syarat-syarat dan penggunaan anda terhadap Perkhidmatan dikawal oleh undang-undang Amerika Syarikat, kecuali untuk peraturan konflik undang-undang AS. Penggunaan anda terhadap Aplikasi juga mungkin tertakluk kepada undang-undang tempatan, negeri, kebangsaan atau antarabangsa yang lain. Sebarang tindakan undang-undang atau prosiding yang berkaitan dengan Syarat-syarat ini akan dibawa secara eksklusif ke mahkamah Amerika Syarikat, dan anda bersetuju untuk tunduk kepada bidang kuasa peribadi mahkamah tersebut.',
    block24:
      'Hubungan Pihak-pihak. Noam dan anda adalah kontraktor bebas, dan tiada pihak yang mempunyai kuasa untuk mewakili atau mengikat pihak satu lagi atau mengambil tanggungjawab bagi pihak satu lagi tanpa kebenaran bertulis terdahulu pihak satu lagi.',
    block25:
      '(b) Penggunaan Jenama. Anda tidak boleh menggunakan nama, logo, atau tanda dagangan Noam atau mana-mana syarikat gabungannya tanpa kebenaran bertulis terdahulu kami.',
    block26:
      'Jika mana-mana peruntukan dalam terma ini ditentukan sebagai tidak sah, haram, atau tidak boleh dikuatkuasakan, peruntukan yang tinggal akan kekal berkuat kuasa penuh.',
    block3:
      'Jika anda berumur di bawah 18 tahun, anda mesti mendapatkan kebenaran daripada ibu bapa atau penjaga sah anda untuk menggunakan Perkhidmatan. Jika anda menggunakan Perkhidmatan atas nama orang lain atau entiti, anda mesti diberi kuasa untuk menerima terma ini atas pihak mereka. Anda mesti memberikan maklumat yang tepat dan lengkap untuk mendaftar akaun. Anda tidak boleh memberikan credential capaian atau akaun anda kepada sesiapa sahaja di luar organisasi anda, dan anda bertanggungjawab untuk semua aktiviti yang dijalankan menggunakan credential anda.',
    block4:
      '(a) Penggunaan Perkhidmatan. Anda boleh mengakses Perkhidmatan berdasarkan terma ini, dan kami memberikan kepada anda hak bukan eksklusif untuk menggunakan Perkhidmatan. Apabila menggunakan Perkhidmatan, anda harus mematuhi terma ini dan semua undang-undang yang berkenaan. Kami dan anak syarikat kami memegang semua hak, tajuk dan kepentingan dalam Perkhidmatan.',
    block5:
      '(b) Maklum balas. Kami menerima maklum balas, ulasan, idea, cadangan dan penambahbaikan dengan baik. Jika anda memberikan sebarang kandungan sedemikian, kami boleh menggunakannya tanpa sebarang sekatan dan tanpa sebarang pampasan kepada anda.',
    block6:
      '(c) Sekatan. Anda tidak boleh: (1) menggunakan Perkhidmatan dengan cara yang melanggar, mengambil secara salah, atau melanggar apa-apa hak orang lain; (2) melakukan kejuruteraan terbalik, mengurai, membongkar, menterjemah, atau cuba untuk mengetahui kod sumber atau komponen asas model, algoritma, dan sistem Perkhidmatan (melainkan sekatan tersebut dilarang oleh undang-undang yang berkenaan); (3) menggunakan output Perkhidmatan untuk membangunkan model yang bersaing dengan Noam; (4) mengekstrak data atau output daripada Perkhidmatan menggunakan sebarang kaedah automatik atau pengaturcaraan melainkan dibenarkan melalui API, termasuk scraping, penuaian web, atau pengekstrakan data web; (5) mewakili output Perkhidmatan sebagai dijana secara buatan apabila ia bukan begitu, atau melanggar dasar penggunaan kami dengan cara lain; (6) membeli, menjual, atau memindahkan kunci API tanpa kebenaran terdahulu kami; atau (7) memberikan kepada kami sebarang maklumat peribadi kanak-kanak di bawah umur 13 tahun atau umur persetujuan digital yang berkenaan. Anda akan mematuhi sebarang had kadar dan keperluan lain dalam dokumentasi kami.',
    block7:
      '(d) Perkhidmatan pihak ketiga. Mana-mana perisian pihak ketiga, perkhidmatan, atau produk lain yang berkaitan dengan Perkhidmatan diatur oleh terma mereka sendiri, dan kami tidak bertanggungjawab atas produk pihak ketiga.',
    block8:
      '(a) Kandungan Anda. Anda boleh memberikan input ("Input") kepada Perkhidmatan dan menerima output ("Output") yang dijana dan dikembalikan berdasarkan Input (secara kolektif dirujuk sebagai "Kandungan"). Di antara pihak-pihak, dan sejauh yang dibenarkan oleh undang-undang yang berkenaan, anda adalah pemilik semua Input. Noam boleh menggunakan Kandungan untuk menyediakan dan mengekalkan Perkhidmatan, mematuhi undang-undang yang berkenaan, dan menguatkuasakan dasar kami. Anda bertanggungjawab ke atas Kandungan, termasuk memastikan ia tidak melanggar mana-mana undang-undang yang berkenaan atau terma ini.',
    block9:
      '(b) Ketepatan. Kecerdasan buatan dan pembelajaran mesin adalah bidang penyelidikan yang berkembang pesat. Kami sentiasa berusaha untuk meningkatkan perkhidmatan kami agar lebih tepat, boleh dipercayai, selamat dan bermanfaat. Memandangkan sifat probabilistik pembelajaran mesin, penggunaan perkhidmatan kami mungkin menghasilkan output yang salah dalam sesetengah kes, yang mungkin tidak mencerminkan individu, tempat atau fakta sebenar dengan tepat. Anda harus menilai ketepatan mana-mana output dengan sewajarnya berdasarkan kes penggunaan anda, termasuk dengan menyemak output secara manual.',
    subTitle1: 'Pendaftaran dan Akses',
    subTitle10: 'Kebolehpisahan',
    subTitle2: 'Keperluan Penggunaan',
    subTitle3: 'Kandungan',
    subTitle4: 'Yuran dan Pembayaran',
    subTitle5: 'Rahsia, Keselamatan, dan Perlindungan Data',
    subTitle6: 'Masa Berlaku dan Penamatan',
    subTitle7: 'Pemindahan Tanggungjawab; Penafian; Had Tanggungjawab',
    subTitle8: 'Undang-Undang Pengawal dan bidang kuasa',
    subTitle9: 'Terma Am',
    title: 'Terma Perkhidmatan',
    updateTime: 'Dikemas kini: 15 Mac 2024',
  },
  trialModal: {
    btn: 'Mula Sekarang（Hanya USD0.99）',
    chat: 'ChatPDF',
    desc1: 'Selepas percubaan anda, anda akan dikenakan yuran tahunan sebanyak $180',
    desc2: 'Batal Pada bila-bila masa',
    focus: 'Memfokuskan',
    hover: 'Terjemahan sorotan',
    image: 'Terjemahan imej',
    installBtn: 'Pasang sekarang untuk menerima hadiah anda',
    memo: 'Pengurusan kegemaran',
    pdf: 'Terjemahan selari PDF',
    realtime: 'Terjemahan segera',
    select: 'Penterjemahan pemilihan perkataan',
    title: 'Hadiah selamat datang',
    trialText: 'Uji Coba 7 Hari',
    video: 'Terjemahan video',
    videoSummary: 'Ringkasan video',
    web: 'Terjemahan Selari',
    webSummary: 'Ringkasan web',
  },
  upgradeModal: {
    btn: 'Naik Taraf Sekarang',
    chat: {
      free: 'Anda telah mencapai had ChatPDF',
      pro: 'Anda telah mencapai had ChatPDF untuk bulan ini',
    },
    contactStr: 'Sila tunggu reset seterusnya, atau hubungi kami di contact@noam.tools.',
    limitAlertStr: 'Anda telah mencapai had pelan percuma. Naik taraf untuk teruskan.',
    more: 'Lihat Pelan',
    pageLimit: { free: 'Anda telah mencapai had halaman PDF' },
    title: 'Pengingat',
    upgradeAlertStr: 'Anda telah mencapai had pelan percuma. Naik taraf untuk teruskan.',
    upload: {
      free: 'Anda telah mencapai had terjemahan PDF anda',
      pro: 'Anda telah mencapai had terjemahan PDF untuk bulan ini',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Sertai Sekarang',
      label: 'Faedah Pengguna Baru:',
      remain: 'Hanya tinggal 30',
      text: 'Hanya 100 Tempat Tersedia! Dapatkan Segera!',
    },
  },
  aiPdfTranslator: {
    title: 'Penterjemah PDF AI Percuma: Terjemahkan PDF dengan Perbandingan dalam sebarang Bahasa',
    desc: 'Mudah menterjemahkan fail PDF ke mana-mana bahasa dengan AI. Bandingkan teks asal dan terjemahan secara bersebelahan, pantas dan percuma.',
    keywords: 'GPT-4、Pembantu AI、Terjemahan、Ringkasan、Fokus、ChatPDF、Nota、kecekapan',
    sourceToTarget: {
      title: 'Alat Terjemahan PDF Percuma: terjemahkan {{source}} kepada {{target}} secara percuma',
      desc: 'Terjemahkan fail PDF anda daripada sebarang bahasa sumber kepada bahasa pilihan anda secara percuma. Terjemahan PDF yang pantas, tepat, dan selamat dikuasakan oleh AI lanjutan.',
    },
    headerIntroduce: {
      title: 'Noam: Lebih Dari Hanya Terjemahan Dalam Talian',
      introduce1: {
        title: 'Noam · Pembaca PDF',
        desc: '✨Terjemahan side-by-side + Soal Jawab AI. Terjemahkan PDF dengan cepat dan tepat ke dalam bahasa sasaran anda. Bertanya secara bebas mengenai kandungan untuk memahami fail PDF anda dengan lebih mendalam.',
      },
      introduce2: {
        title: 'Noam · Sambungan Terjemahan Sisi-dengan-Sisi',
        desc: '👏Selesaikan semua keperluan terjemahan halaman web anda:',
        detail1: { title: 'Terjemahan Halaman Web:', desc: 'Paparan dwibahasa berdampingan' },
        detail2: { title: 'Terjemahan Perkataan:', desc: 'Terjemahan pantas dengan satu klik' },
        detail3: {
          title: 'Terjemahan Segera:',
          desc: 'Terjemahkan perkataan atau ayat dengan serta-merta.',
        },
        detail4: {
          title: 'Terjemahan Imej:',
          desc: 'Gantikan imej dengan yang telah diterjemahkan.',
        },
        detail5: {
          title: 'Terjemahan Video:',
          desc: 'Subtajak dwibahasa untuk penonton yang lebih baik.',
        },
        footer: 'Nikmati lebih banyak ciri bacaan berkuasa AI untuk terjemahan yang lebih pintar!',
      },
    },
    subtitle: 'Terjemahkan PDF Secara Dalam Talian Percuma',
    introduce: {
      module1: {
        detail1: {
          title: 'Terjemahan PDF Secara Serentak dalam Masa Nyata',
          desc1:
            'Memaparkan kandungan asal dan diterjemahkan dengan serta-merta dalam susunan bersebelahan yang disegerakkan',
          desc2: 'Bandingkan kedua-dua versi dengan mudah dengan gelongsor segerak',
          desc3: 'Menjaga format yang sama untuk pengalaman membaca yang konsisten',
        },
        detail2: {
          title: 'Penjajaran dan Pengesahan Kandungan yang Tepat',
          desc1:
            'Penjajaran yang sempurna antara teks sumber dan terjemahan untuk tujuan pengesahan yang mudah',
          desc2: 'Setiap segmen kandungan sepadan dengan tepat antara kedua-dua versi',
          desc3:
            'Cepat mengenal pasti dan menyelesaikan percanggahan terjemahan untuk hasil yang boleh dipercayai',
        },
      },
      module2: {
        detail1: {
          title: 'Pelbagai Model AI Lanjutan untuk Terjemahan yang Tepat',
          desc1: 'Pilih daripada model AI terkemuka untuk memenuhi keperluan terjemahan anda',
          desc2: 'Memastikan hasil optimum untuk pelbagai jenis dokumen dan industri',
          desc3:
            'Pilihan model yang fleksibel menyediakan penyelesaian tersuai untuk setiap senario',
        },
        detail2: {
          title: 'Terjemahan AI Lanjutan untuk Setiap Jenis Kandungan',
          desc1:
            'Model AI kami yang canggih memastikan ketepatan tinggi dan pemahaman bahasa semula jadi',
          desc2: 'Mengendalikan dokumen teknikal, akademik, dan kreatif dengan mudah',
          desc3: 'Menghasilkan hasil yang boleh dipercayai untuk semua keperluan terjemahan anda',
          desc4: 'Penyesuaian pintar kepada jenis kandungan yang berbeza untuk prestasi optimum',
        },
      },
      module3: {
        detail1: {
          title: 'Interaksi Dokumen Cerdas',
          desc1: 'Berbual dengan mudah dengan fail PDF dan persembahan anda menggunakan AI canggih',
          desc2:
            'Tanyakan soalan tentang kandungan dokumen dengan serta-merta dan terima jawapan yang tepat',
          desc3: 'Cipta ringkasan ringkas dengan cepat untuk dokumen panjang',
        },
        detail2: {
          title: 'Analisis Kandungan Mendalam dan Integrasi Tanpa Halangan',
          desc1: 'Ekstrak maklumat utama dan analisis data kompleks dengan pemahaman berkuasa AI',
          desc2: 'Memperoleh wawasan tentang bahan teknikal, akademik, atau kreatif',
          desc3:
            'Diintegrasikan dengan lancar dengan Penterjemah PDF kami untuk penyelesaian pengurusan dokumen yang lengkap',
        },
      },
      module4: {
        detail1: {
          title: 'Lebih dari Terjemahan PDF: Penyelesaian Terjemahan Laman Web Semua-dalam-Satu',
          desc: 'Temui sambungan terjemahan berdampingan yang kuat kami yang direka untuk setiap senario membaca dalam talian.',
          desc1:
            'Terjemahan Laman Web: Nikmati kandungan dwibahasa dengan paparan sisi demi sisi yang disegerakkan',
          desc2:
            'Terjemahan Perkataan: Terjemahkan perkataan yang diserlahkan serta-merta dengan satu klik sahaja',
          desc3:
            'Terjemahan Segera: Terjemahkan sebarang teks atau ayat serta-merta untuk pemahaman yang cepat',
          desc4: 'Terjemahan Imej: Gantikan imej asal dengan versi terjemahan secara automatik',
          desc5:
            'Terjemahan Video: Tonton video dengan subtitle dwibahasa untuk pengalaman yang lebih baik',
        },
      },
    },
    question: {
      title: 'Soalan Lazim Yang Diajukan',
      answer1: {
        title: 'Adakah Noam PDF Translator percuma untuk digunakan bagi terjemahan PDF?',
        content:
          'Ya, anda boleh menterjemahkan PDF secara percuma dengan Penterjemah PDF Sider! Kami menawarkan kuota percuma sebanyak 5,000 token, yang mencukupi untuk menterjemahkan kebanyakan dokumen PDF yang biasa ditemui di pasaran. Jika anda perlu menterjemahkan fail yang lebih besar atau memerlukan ciri lanjutan, anda boleh memilih untuk menaik taraf kepada pelan premium kami untuk lebih banyak keupayaan.',
      },
      answer2: {
        title: 'Seberapa tepatkah Penterjemah PDF Noam?',
        content:
          'Noam PDF Translator menyediakan terjemahan yang sangat tepat dengan menggunakan teknologi AI canggih dan memahami konteks dokumen anda dengan mendalam. Walaupun tiada terjemahan automatik yang sempurna, paparan berdampingan kami membolehkan anda menyemak dan menyempurnakan setiap terjemahan dengan mudah, memastikan hasil akhir memenuhi jangkaan kualiti anda. Rasai terjemahan PDF yang boleh dipercayai dan tepat dengan Noam.',
      },
      answer3: {
        title: 'Bolehkah saya menterjemahkan PDF yang diimbas?',
        content:
          'Ya, anda boleh menterjemahkan PDF yang diimbas dengan teknologi OCR (Optical Character Recognition) terbina dalam kami. Sistem kami secara automatik mengekstrak teks daripada dokumen yang diimbas dan PDF berasaskan imej, kemudian menterjemahkan kandungannya untuk anda. Ini memastikan bahawa walaupun PDF yang tidak boleh diedit atau hanya mengandungi imej boleh diterjemahkan dengan tepat.',
      },
      answer4: {
        title: 'Berapa lama masa yang diperlukan untuk terjemahan?',
        content:
          'Penterjemahan adalah cepat dan cekap— kebanyakan dokumen diproses dalam beberapa saat hingga beberapa minit, bergantung kepada panjang dan kerumitannya. Contohnya, PDF standard 10 mukasurat biasanya mengambil masa kurang daripada 2 minit untuk diterjemahkan. Nikmati masa penyelesaian yang cepat untuk semua keperluan penterjemahan dokumen anda!',
      },
      answer5: {
        title: 'Bolehkah saya kekalkan paparan sebelah demi sebelah untuk membaca?',
        content:
          'Ya, anda sentiasa boleh membaca dokumen anda secara berdampingan. Tataletak ini membolehkan anda membandingkan kandungan asal dan terjemahan dengan mudah, memastikan pengalaman membaca yang lancar dan cekap.',
      },
    },
    freeTrial: 'Uji Percubaan Percuma',
    toLanguage: { title: 'Pasangan Terjemahan AI PDF', item: '{{sumber}} ke {{sasaran}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Ciri-ciri',
      blog: 'Blog',
      pricing: 'Harga',
      button: 'Terjemahkan Sekarang',
      faq: 'Soalan Lazim yang Diajukan',
    },
    hero: {
      upload: {
        title: 'Muat naik PDF anda',
        highlight: 'Klik untuk lawati',
        max: 'Max',
        desc: 'atau seret dan lepaskan',
      },
      pill: 'Penterjemah PDF Berkuasa AI',
      title: 'Penterjemah PDF Percuma',
      to: 'kepada',
      model: 'GPT-4 & Claude',
      desc: 'Terjemahan segera dan tepat yang mengekalkan susunan asal. Noam AI menyokong OCR dan paparan sebelah menyebelah.',
      support: 'Sokongan OCR',
      free: 'Cuba Percuma',
      translated: 'Diterjemahkan oleh Noam',
      complete: 'Penterjemahan Selesai',
    },
    ticker: {
      ocr: 'Teknologi OCR',
      pdf: 'Terjemahan PDF',
      format: 'Pemeliharaan Format',
      multi: 'Pelbagai Bahasa',
      web: 'Terjemahan Web',
      chat: 'Bercakap dengan PDF',
      side: 'Sisi-dengan-Sisi',
      secure: 'Selamat & Peribadi',
    },
    comparison: {
      bad: {
        title: 'Terjemahan Standard',
        head: 'Format dan Konteks Hilang',
        text1: 'Ralat: Tataletak rosak. Gambar salah tempat.',
        text2: 'Teks bertindih dan fon tidak konsisten. Sukar dibaca dan tidak profesional...',
      },
      dump: { title: 'Dump Teks Kosong' },
      good: {
        title: 'Terjemahan AI Noam',
        tag: 'Hasil Sempurna',
        sub: 'Formatting Sempurna, Sedar Konteks',
      },
      title: 'Mengapa Memilih Noam AI?',
      desc: 'Hentikan perjuangan dengan terjemahan tampal-tampal. Rasai perbezaan antara alat standard dan terjemahan peka konteks berkuasa AI kami.',
    },
    showcase: {
      title2: 'Bahasa Apa Saja',
      kicker: 'DOKUMEN YANG DIDUKUNG',
      title1: 'Apa-apa Dokumen',
      carousel1: 'Seni',
      carousel2: 'Arkitektur',
      carousel3: 'Jurnal akademik',
      carousel4: 'Ubat',
      note: 'Tangani dokumen teknikal, akademik dan kreatif dengan mudah.',
      carousel5: 'Kewangan',
      carousel6: 'Undang-undang',
      carousel8: 'Dasar',
      carousel7: 'Kontrak',
    },
    features: {
      big: {
        title: 'Model AI Tingkat Lanjut (GPT-4, Claude)',
        desc: 'Pilih daripada model AI terkemuka untuk memenuhi keperluan terjemahan anda. Pastikan hasil yang optimum untuk pelbagai jenis dokumen.',
      },
      grid1: {
        title: 'Sokongan OCR',
        desc: 'Ekstrak dan terjemahkan teks dari PDF yang diimbas dan imej dengan serta-merta.',
      },
      grid2: {
        title: 'Eksport Resolusi Tinggi',
        desc: 'Muat turun dokumen terjemahan anda dalam format PDF dengan susunan asal.',
      },
      grid3: {
        title: 'Perbandingan Bersebelahan',
        desc: 'Penggelongsoran segerak untuk membandingkan teks asal dan terjemahan.',
      },
      title1: 'Lebih dari sekadar Terjemahan',
      title2: 'Ia adalah Revolusi',
      line1: 'Kertas Teknikal.pdf',
      line2: 'Mengesan Bahasa: Inggeris...',
      line3: 'Model: GPT-4o (Ketepatan Tinggi)',
      line4: 'Terjemahan Selesai (Kejituan 99%)',
    },
    testimonials: {
      review1: {
        role: 'Penyelidik',
        content:
          'Noam AI telah menjimatkan saya berjam-jam dalam menterjemahkan kertas akademik. Paparan berdampingan amat membantu untuk mengesahkan istilah teknikal.',
      },
      review2: {
        role: 'Pemasar Global',
        content:
          'Penterjemah PDF terbaik yang pernah saya gunakan. Ia mengekalkan format asal dengan sempurna, yang sangat penting untuk deck pemasaran kami.',
      },
      review3: {
        role: 'Penyelidik Undang-Undang',
        content:
          'Tepat dan cepat. Saya menggunakannya untuk terjemahan kontrak dan ciri OCR untuk dokumen yang diimbas berfungsi dengan sempurna.',
      },
      kicker: 'Dicintai Pengguna',
      title: 'Apa Kata Pengguna Kami',
    },
    cta: {
      title: 'Sedia untuk Memecahkan Halangan Bahasa?',
      hint: '',
      button: 'Mulakan Terjemahan Percuma',
      desc: 'Sertai lebih dari 10,000 pengguna dan mulakan menterjemahkan dokumen anda dengan Noam AI hari ini.',
    },
    languagePairs: {
      title: 'Pasangan Terjemahan AI PDF Bahasa Inggeris',
      desc: 'Arah terjemahan popular yang disokong oleh Noam AI',
    },
    footer: { about: 'Tentang Kami', privacy: 'Dasar Privasi', contact: 'Hubungi Sokongan' },
  },
}

export default TRANSLATION
